export interface AccountTemplate {
  RecordType: any;
  LnStatus: any;
  LeadStatus: any;
}

export interface Account {
  name: string;
  id: number;
  recordType: string;
  recordTypeLabel: string;
  businessPartnerNo: string;
  address: string;
  lnStatus: number;
  lnStatusLabel: string;
  leadStatus: string;
  employeeId: string;
  childName1: string;
}

export class AccountResponse {
  count: number;
  accounts: Account[];

  constructor() {
    this.count = 0;
    this.accounts = [];
  }
}
